import React from "react";
import Tireone from ".././components/Section/TirereinforcementOne"
import Tiretwo from ".././components/Section/TirereinforcementTwo"


function Tire() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
       <Tireone/>
       <Tiretwo/>
        
      
    </div>
  );
}

export default Tire;
